<template>
    <BuilderBase :loading="datasetStore.loading">
        <template v-slot:section-title>
            <div class="content">
                <h1 class="h1">
                    <span class="steps">{{$t('common.step_1')}} 3<span class="slash">/</span>3:</span> <span class="title" >{{$t('views.dataset_method.title_short')}}</span>
                </h1>
            </div>
        </template>

        <template v-slot:section-content>
            <ToggleSimple :toggleable="false" :default="true" cssClass="toggle-type-2 important-title">
                <template #toggle>
                    <div class="left">
                        <div v-if="$te('views.dataset_method.title')" class="toggle-text">
                            {{ $t('views.dataset_method.title') }}
                        </div>
                        <div v-if="$te('views.dataset_method.description')" class="toggle-description">
                            {{ $t('views.dataset_method.description') }}
                        </div>
                    </div>
                </template>

                <template #content>
                    <div class="builder-method-type-1">
                        <MethodForm />
                    </div>
                </template>
            </ToggleSimple>
        </template>
    </BuilderBase>
</template>

<script>
    import i18nViewMixin from '@/mixins/i18nViewMixin';
    import { useDatasetStore } from '@/stores/dataset';
    import MethodForm from '@/components/forms/DatasetMethodForm';
    import BuilderBase from '@/views/builder/BuilderBase';
    import ToggleSimple from '@/components/elements/misc/ToggleSimple';

    export default {
        name: 'HomeView',
        mixins: [i18nViewMixin],
        components: {
            MethodForm,
            BuilderBase,
            ToggleSimple
        },
        data() {
            return {
                seo_title: 'views.dataset_method.seo_title'
            };
        },
        computed: {
            datasetStore() {
                return useDatasetStore();
            }
        },
        async mounted() {
            if(!this.datasetStore.price || !this.datasetStore.query) {
                const success = await this.datasetStore.fetchDataset(true);
                if(!success || !this.datasetStore.count || !this.datasetStore.price || !this.datasetStore.query) {
                    this.$router.push({name: 'builder'});
                }
            }
        }
    }
</script>